import { render, staticRenderFns } from "./ParallaxVertical.vue?vue&type=template&id=af831d22&scoped=true&"
import script from "./ParallaxVertical.vue?vue&type=script&lang=js&"
export * from "./ParallaxVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af831d22",
  null
  
)

export default component.exports